import React from 'react';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import SlideBanner from '@components/common/SlideBanner/SlideBanner';
import ServicePackageNav from '@components/ServicePackage/ServicePackageNav';
import ServicePackageList from '@components/ServicePackage/ServicePackageList';
import {NextSeo} from 'next-seo';
import AppConfigService from '@services/app-config.service';
import NewsService from '@services/news.service';
import {getAutoSEO} from '@helper/seo/seo';

export default function GoiDichVu(props) {
    const {locale} = useRouter();
    const {seoPage} = props;
    
    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
            <SlideBanner titleBanner={getLocaleContent(locale, 'page.service-package.page-title')} />
            <ServicePackageNav />
            <ServicePackageList />
        </div>
        </>
    );
}

GoiDichVu.getInitialProps = async (context) => {
    try {
        const ctx = context || {};
        const appConfigService = new AppConfigService(ctx);
        const seoConfig = await appConfigService.getAppConfig({page: 'SEO'});
        
        // Fetch data thực tế để tạo SEO tự động
        let pageData = {};
        try {
            const newsService = new NewsService(ctx);
            const packagesResponse = await newsService.getServicePackageList({
                locale: ctx.locale || 'vn',
                pageSize: 1,
                pageIndex: 1
            });
            const packages = packagesResponse?.data || [];
            pageData.totalPackages = Array.isArray(packages) ? packages.length : 0;
        } catch (err) {
            console.error('Failed to fetch service packages data for SEO:', err);
        }
        
        // Sử dụng getAutoSEO để tạo SEO tự động từ data
        let seoPage = getAutoSEO('GOIDICHVU', seoConfig, pageData);
        
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || 'https://tnh.com.vn';
        seoPage.canonical = `${webUrl}/goi-dich-vu`;
        if (seoPage.openGraph) {
            seoPage.openGraph.url = `${webUrl}/goi-dich-vu`;
        }
        
        return {seoPage};
    } catch (error) {
        console.error('Failed to fetch SEO for service package page:', error);
        return {seoPage: null};
    }
};

